import * as React from "react";
import {cx} from "emotion";

import "./mailing-options.scss";

import {cs}   from "@Common/react/chain-services";
import {scnv} from "@Common/react/state-change-nested-value";

import {HeaderOptions} from "../header-options/header-options";

export const MailingOptions = (
    {
        className=undefined,
        mailingClass: {
            state: mailingClassState,
            mailingClassKeys,
            forcedStandard,
            hasEddm, canadaMailing
        },
        renderAddressLists,
    }
) => cs(
    ({}) => (
        <div className={cx("mailing-options-0k3", className)}>
            {HeaderOptions({
                className: "section",
                list: mailingClasses({canadaMailing, hasEddm, mailingClassKeys}).map((c) => ({
                    key: c.value,
                    selected: c.value === mailingClassState.value,
                    disabled: (
                        (!mailingClassKeys.includes(c.value)) ? (
                            {
                                tooltip: "The selected template does not allow this mailing class.",
                            }
                        ) : (!["3", "5"].includes(c.value) && forcedStandard) ? (
                            {
                                tooltip: "First Class Mail can not be selected for EDDM lists.",
                            }
                        ) : (
                            null
                        )
                    ),
                    description: c.description,
                    labels: c.labels,
                    onSelect: () => scnv(mailingClassState, [], () => c.value),
                })).filter( (c) => !c.disabled),
            })}

            {renderAddressLists()}
        </div>
    ),
);


const mailingClasses = ({canadaMailing, hasEddm, mailingClassKeys}) => {
    if (mailingClassKeys.includes("5")) {
        return [{
            value: "5",
            labels: [
                {
                    text: "Neighborhood Direct Mail",
                    toolTip : () => "Discounted rate for delivering your mailed piece to every door in your selected USPS carrier routes, and will include Recipient Name",
                }
            ],
            description: "Neighborhood Direct Mail requires a minimum qty of 500 pieces. The United States Postal Service average delivery time is 5-15 business days.",
        }];
    }
    return [
        {
            value: "1",
            labels: [
                {
                    text: canadaMailing ? "Canadian Lettermail" : "First Class Mail",
                    toolTip : () => "Best option for time-sensitive mailings. Mail will not be returned if undeliverable",
                },
            ],
            description: canadaMailing ? "Canada Post delivery time is 5 - 8 business days" : "Best option for time-sensitive mailings. The United States Postal Service average delivery time is 3-5 business days.",
        },
        {
            value: "3",
            labels: canadaMailing ? [
                {
                    text: "Canadian Admail",
                    toolTip : () => "Mail will not be returned if undeliverable",
                },
            ] : [
                    {
                        text: "Standard Mail",
                        toolTip : () => "Mail will not be returned if undeliverable",
                    },
                    hasEddm && {
                        text: "or EDDM ELITE",
                        toolTip : () => "An enhanced version of USPS EDDM® that includes recipient names on most mailing addresses",
                    },
                ].filter(v=>v)
        ,
            description: canadaMailing ? "Canada Post delivery time is 7 - 14 business days" : 
                "Standard delivery time. The United States Postal Service average delivery time is 5-15 business days. Standard Mail is not forwarded or returned if undeliverable.",
        },
    ];
};
